export function validatePhone(phone: string) {
  return /^\+[\d]{11}$/.test(phone);
}
